import 'custom-media-element';
import 'hls-video-element';
import 'media-chrome';
import { KoiAdsManager } from './ads';
import { KoiAnalytics } from './analytics';
import BasePlayer from './base-player';
import KoiAudioPlayer from './koi-audio-player';
import KoiCardAudioPlayer from './koi-card-audio-player';
import KoiPlayer from './koi-player';
import KoiVideoPlayer from './koi-video-player';
import { PlayerUiControl } from './player-ui-control';
import { PlayerUiOptions } from './player-ui-options';

if (typeof window !== 'undefined' && 'customElements' in window) {
  if (!customElements.get('koi-player')) {
    customElements.define('koi-player', KoiPlayer);
  }
  if (!customElements.get('koi-audio-player')) {
    customElements.define('koi-audio-player', KoiAudioPlayer);
  }
  if (!customElements.get('koi-video-player')) {
    customElements.define('koi-video-player', KoiVideoPlayer);
  }
  if (!customElements.get('koi-card-audio-player')) {
    customElements.define('koi-card-audio-player', KoiCardAudioPlayer);
  }
}

export {
  BasePlayer,
  KoiAdsManager,
  KoiAnalytics,
  KoiAudioPlayer,
  KoiPlayer,
  KoiVideoPlayer,
  PlayerUiControl,
  PlayerUiOptions,
};

export default KoiPlayer;
